const INTEGER_PATTERN = /^-?\d+$/;

/**
 * Parser dei valori della query string per `parseSearchWith`: JSON come il
 * default del router, ma un numero intero oltre `Number.MAX_SAFE_INTEGER`
 * (CRO, codici transazione incollati in un link) resta testo, altrimenti
 * perderebbe le ultime cifre. Un valore non JSON solleva: il router ripiega
 * sul testo grezzo.
 */
export function parseSearchValue(value: string): unknown {
  const parsed: unknown = JSON.parse(value);
  const isRoundedInteger =
    typeof parsed === 'number' &&
    !Number.isSafeInteger(parsed) &&
    INTEGER_PATTERN.test(value);
  return isRoundedInteger ? value : parsed;
}
